<template>
<div>

  <div :class="{ 'bg-white opacity-0 animated fadeInToFifty fixed pin z-50 flex items-center justyify-center' : mask }"></div>

  <div class="spinner-box animated slower fadeIn" :class="{ 'fixed pin z-50 flex items-center justyify-center' : mask }">

    <div class="spinner" :style="themeStyle"></div>

    <div v-if="text" class="spinner-text" :style="textStyle">{{ text }}</div>

  </div>

</div>
</template>

<script>
export default {

  name: 'Spinner',

  props: {
    mask: { type: Boolean, default: false },
    theme: { type: String, default: '' },
    text: { type: String, default: '' },
    textColor: { type: String, default: '#004f45' }
  },

  computed: {

    themeColor() {
      let map = { 'green': '#004f45', 'white': '#FFFFFF' };
      return map[this.theme] || map['green'];
    },

    themeStyle() {
      return this.mask ? '' : {
        borderTopColor: 'transparent',
        borderRightColor: this.themeColor,
        borderBottomColor: this.themeColor,
        borderLeftColor: this.themeColor
      };
    },

    textStyle() {
      return { color: this.textColor };
    }

  }

}
</script>
